import * as React from 'react';
import {ErrorMessage, Field} from 'formik';
import {Form, FormProps} from '../form/Form';
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';

interface LoginFormProps extends TranslationProps {
  [key: string]: any
}

class LoginForm extends Form<LoginFormProps & FormProps, any> {

  constructor(props: LoginFormProps) {
    super(props);
  }

  protected handleValidate(oldValues: any, oldErrors: any, values: any): any {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      this.emitValidating(true, false);
      const errors: any = {};

      if (!values.email) {
        errors.email = this.props.textsContent?.['AUTH_ERROR_REQUIRED'] ?? 'Ce champ est obligatoire';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = this.props.textsContent?.['AUTH_ERROR_INVALID_EMAIL'] ?? 'Cette adresse e-mail est invalide';
      }

      if (!values.password) {
        errors.password = this.props.textsContent?.['AUTH_ERROR_REQUIRED'] ?? 'Ce champ est obligatoire';
      }

      if(localStorage.getItem('i18nLang')) {
        values.langId = JSON.parse(localStorage.getItem('i18nLang')).id ?? 1;
      }

      this.emitResult(values, errors, resolve, reject);
    });
  }

  protected formRender(isSubmitting: boolean): any {
    return (
      <div className="d-flex flex-column">
        <label for-html="email"></label>
        <Field required placeholder={this.props.textsContent?.['AUTH_LOGIN_ADDRESS'] ?? 'Adresse e-mail'} type="email" name="email" id="email" className="inputStyle form-control" />
        <ErrorMessage name="email" component="div"  className="errorMessageReact" />

        <Field autocomplete="off" required placeholder={this.props.textsContent?.['AUTH_LOGIN_PASSWORD'] ?? 'Mot de passe'} type="password" name="password" className="inputStyle form-control mt-4" />
        <ErrorMessage name="password" component="div"  className="errorMessageReact" />
        {(this.props.internalSubmitBtn || false) &&
          <button type="submit" disabled={isSubmitting} className="buttonPrimary">
            {this.props.textsContent?.['AUTH_LOGIN_BTN_CONNEXION'] ?? 'Connexion'}
          </button>
        }
        <div className="resetPasswordContainer text-left">
          <a className="resetPassword dark-grey cursor-pointer text-underline" href={this.props.resetUrl as any || "customer-reset"}>
            <u>{this.props.textsContent?.['AUTH_FORGET_PASSWORD'] ?? 'J ai oublié mon mot de passe'}</u>
          </a>
        </div>
      </div>
    );
  }
}

export default WithTranslation(LoginForm, 'AUTH_TUNNEL', 'EXCEPTIONS');
